//
// broadcast selected value on change
//
import { component as defineComponent } from 'flightjs';

var broadcastingInput = function() {
    this.attributes({
        broadcastEvent: ''
    });

    this.after('initialize', function() {
        this.on('change', this.broadcastAction);
    });

    this.broadcastAction = function(e) {
        var value;

        if (e.currentTarget.type === 'checkbox') {
            value = e.currentTarget.checked;
        } else {
            value = e.currentTarget.value;
        }

        this.trigger(this.attr.broadcastEvent, {
            name: e.currentTarget.name,
            value: value,
        });
    };
};

export default defineComponent(broadcastingInput);



// WEBPACK FOOTER //
// ./src/web/js/contest/ui/broadcasting-input.js